import type { AnyShippingMethod } from "@jti/commerce";

import type { FormFieldConfig } from "@checkout-v2/formFields/types/FormFieldConfig.types";

export type ShippingMethodDefaultValueOptions = {
  isShippingAgeVerificationEnabled: boolean;
  isAgeVerified: boolean;
};

export type ShippingMethodCodeFieldOption = {
  value: string;
  label: string;
  type: AnyShippingMethod["type"];
  icon?: string;
  disableForNotAgeVerified?: boolean;
};

export type ShippingMethodCodeFieldConfig = FormFieldConfig<
  "shippingMethodCode",
  {
    options: ShippingMethodCodeFieldOption[];
  }
>;
